import Vue from 'vue'
import Router from 'vue-router'

import AdminRoom from '@/views/AdminRoom'
import ClassRoom from '@/views/ClassRoom'
import CreateClass from '@/views/CreateClass'
import ClassInfo from '@/views/ClassInfo'
import Playback from '@/views/Playback'
import Audit from '@/views/Audit'

Vue.use(Router)

Router.prototype.goBack = function(num=-1) {
  this.isBack = true
  window.history.go(num)
}

export default new Router({
  routes: [
    {
      path:'/',
      redirect:'/adminroom'
    },
    {
      path:'/audit',
      name:'Audit',
      component:Audit
    },
    {
      path:'/adminroom',
      name:'AdminRoom',
      component:AdminRoom
    },
    {
      path:'/classroom',
      name:'ClassRoom',
      component:ClassRoom
    },
    {
      path:'/createclass',
      name:'CreateClass',
      component:CreateClass
    },
    {
      path:'/classinfo',
      name:'ClassInfo',
      component:ClassInfo
    },
    {
      path:'/playback',
      name:'Playback',
      component:Playback
    },
    {
      path:'*',
      redirect: "/adminroom"
    }
  ]
})
